import React from "react";
import Box from "@mui/material/Box";
import MainLayout from "../../nav/MainLayout";
import { styled } from "@mui/material/styles";
import Footer from "../../reusables/Footer";
import AuditAdmin from "./AuditAdmin";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const LeadAudit = () => {
  return (
    <div id="mars-audit">
      <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
        <MainLayout />
        <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
          <DrawerHeader />
          <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />
          <div id="mainHome">
            <AuditAdmin />
          </div>
          <Footer />
        </Box>
      </Box>
    </div>
  );
};

export default LeadAudit;
